import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useSystem'

import type { SystemModel } from '@models/types'

const SystemListItem = (props: { system: SystemModel }) => {
  const { system } = props
  const { id, url, title } = system

  const { editSystemUrl } = generateUrls(system)

  return (
    <DashboardModuleListItem
      href={editSystemUrl}
      secondaryText={url}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default SystemListItem
